import { render, staticRenderFns } from "./ReturnSelectItems.vue?vue&type=template&id=bc3eebc2&"
import script from "./ReturnSelectItems.vue?vue&type=script&lang=js&"
export * from "./ReturnSelectItems.vue?vue&type=script&lang=js&"
import style0 from "./ReturnSelectItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3eebc2')) {
      api.createRecord('bc3eebc2', component.options)
    } else {
      api.reload('bc3eebc2', component.options)
    }
    module.hot.accept("./ReturnSelectItems.vue?vue&type=template&id=bc3eebc2&", function () {
      api.rerender('bc3eebc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnSelectItems.vue"
export default component.exports